// auto-generated by Typewriter template _enums.tst from PortCall.Models\TopicCards\TopicCard.cs
export enum TopicCardStatus { 
    PendingReview = 0,
    Confirmed = 1,
    Denied = 2
}

export const TopicCardStatusDisplayName : { [val : number] : string } = { 
    0: 'Pending Review',
    1: 'Confirmed',
    2: 'Denied'
}

export const TopicCardStatuses : { Id : TopicCardStatus, Name : string }[] = [ 
    { Id: TopicCardStatus.PendingReview, Name: 'Pending Review' },
    { Id: TopicCardStatus.Confirmed, Name: 'Confirmed' },
    { Id: TopicCardStatus.Denied, Name: 'Denied' }
]



// WEBPACK FOOTER //
// ./server/enums/TopicCardStatus.ts